import regexForm from '../../../utils/regexForm';

const { firstname, productExternalReference, simpleText } = regexForm;

export const updateProductInputsPatterns = [
    {
        name: 'productName',
        pattern: firstname,
        type: 'text',
    },
    {
        name: 'productExternalReference',
        pattern: productExternalReference,
        type: 'text',
    },
    {
        name: 'emissionExternalId',
        pattern: productExternalReference,
        type: 'text',
    },
    {
        name: 'emissionFactorSource',
        type: 'text',
    },
    {
        name: 'emissionFactorName',
        type: 'text',
    },
    {
        name: 'emissionFactorValue',
        type: 'text',
    },
];

export const addManuallyInputsPatterns = [
    {
        name: 'productName',
        pattern: simpleText,
        type: 'text',
    },
    {
        name: 'productExternalReference',
        pattern: productExternalReference,
        type: 'text',
    },
    {
        name: 'emissionExternalId',
        pattern: simpleText,
        type: 'text',
    },
    {
        name: 'emissionFactorName',
        type: 'text',
    },
    {
        name: 'emissionFactorValue',
        type: 'text',
    },
];

export const statusOptions = {
    MONETARY: {
        colorPallet: 'wab',
        color: 'grey60',
        icon: 'WidgetIcon',
    },
    EQUIVALENCE: {
        colorPallet: 'status',
        color: 'success',
        icon: 'LinkIcon',
    },
    NO_MATCH: {
        colorPallet: 'status',
        color: 'warning',
        icon: 'EmptyIcon',
    },
};
